import * as React from 'react';

import { Color } from '../../enums';
import { Icon } from '../icon/icon.component';

import { Container, IconContainer, LabelContainer } from './artworkIcon.styled';
import { ArtworkIconProps } from './artworkIcon.types';

export const ArtworkIcon: React.FC<ArtworkIconProps> = (props: ArtworkIconProps): JSX.Element => {
  const { label, icon, color = Color.Black, onClick, id, className }: ArtworkIconProps = props;

  return (
    <Container className={className} onClick={onClick} id={id}>
      {icon && (
        <IconContainer>
          <Icon name={icon} size={20} color={color} />
        </IconContainer>
      )}
      <LabelContainer $color={color}>{label}</LabelContainer>
    </Container>
  );
};
